import defaultIcon from "@/images/curriculum/default.png";
import elIcon from "@/images/curriculum/el.png";
import epsSpireIcon from "@/images/curriculum/eps_spire.png";
import kiddomIcon from "@/images/curriculum/kiddom.png";
import ufliIcon from "@/images/curriculum/ufli.png";
import wondersIcon from "@/images/curriculum/wonders.png";
import bluebonnetIcon from "@/images/curriculum/bluebonnet.png";

export const CurriculumIcons: {[key: string]: string} = {
  bluebonnet: bluebonnetIcon,
  el: elIcon,
  eps_spire: epsSpireIcon,
  kiddomel: elIcon,
  ufli: ufliIcon,
  wonders: wondersIcon,
  default: defaultIcon,
};
